export default __webpack_public_path__ + "static/media/icon-pause2.57424541.svg";